// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"3524":"app","8096":"vendors"}[chunkId] + "." + {"3524":"bf63323c9b1a066cc270","8096":"097835bcced943b4654a"}[chunkId] + ".css";
};